import { render, staticRenderFns } from "./DownloadBtn.vue?vue&type=template&id=6a6c54fe&scoped=true"
import script from "./DownloadBtn.vue?vue&type=script&lang=ts"
export * from "./DownloadBtn.vue?vue&type=script&lang=ts"
import style0 from "./DownloadBtn.vue?vue&type=style&index=0&id=6a6c54fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c54fe",
  null
  
)

export default component.exports